// ─── NotFoundPage.jsx ───────────────────────────────────────────────────────
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { DirectionsCar } from '@mui/icons-material';

export const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 4 }}>
      <DirectionsCar sx={{ fontSize: 80, color: 'primary.main', mb: 2 }} />
      <Typography variant="h2" fontWeight={700} color="primary">404</Typography>
      <Typography variant="h5" color="text.secondary" sx={{ mb: 3 }}>Page not found</Typography>
      <Button variant="contained" onClick={() => navigate('/dashboard')}>Go to Dashboard</Button>
    </Box>
  );
};
export default NotFoundPage;
